export function getValueAfterLastSlash(slug: string) {
    const lastIndex = slug.lastIndexOf("/")
    return slug.substring(lastIndex + 1)
}
